module.exports = __webpack_public_path__ + "TB_Powerup_SFX_B.wav.d5264b42.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/power_up/TB_Powerup_SFX_B.wav.mp3
// module id = 507
// module chunks = 0